import { render, staticRenderFns } from "./AuditPendingDomains.vue?vue&type=template&id=e9157aa8&scoped=true&"
import script from "./AuditPendingDomains.vue?vue&type=script&lang=js&"
export * from "./AuditPendingDomains.vue?vue&type=script&lang=js&"
import style0 from "./AuditPendingDomains.vue?vue&type=style&index=0&id=e9157aa8&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "e9157aa8",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VBtn } from 'vuetify/lib/components/VBtn';
import { VCheckbox } from 'vuetify/lib/components/VCheckbox';
import { VCol } from 'vuetify/lib/components/VGrid';
import { VDataTable } from 'vuetify/lib/components/VDataTable';
import { VRow } from 'vuetify/lib/components/VGrid';
import { VSkeletonLoader } from 'vuetify/lib/components/VSkeletonLoader';
import { VTextField } from 'vuetify/lib/components/VTextField';
installComponents(component, {VBtn,VCheckbox,VCol,VDataTable,VRow,VSkeletonLoader,VTextField})
